<template>
  <div style="width: 90%; margin: auto;">
    <div style="margin-bottom: 10px">
      <el-input prefix-icon="el-icon-search"
                clearable
                v-model="searchText"
                style="width: 260px;"
                placeholder="车牌号"></el-input>
      <el-button style="margin-left: 10px" @click="loadData">查询</el-button>
    </div>
    <div style="display: flex; flex-direction: column; background-color: #ebecf0">
      <div style="flex-grow: 1; display: flex; border-width: 2px" class="table-border">
        <div
          style="flex-shrink: 0; width: 36px; background-color: #1890ff; color: #f6f6f6; display: flex; align-items: center;">
          <div style="margin-left: 11px">应交延迟</div>
        </div>

        <div style="overflow-x: auto;" v-loading="loading">
          <div :style="overdueContainerStyle"
               style="display: flex; height: calc(50vh - 110px); font-size: 14px;">
            <div v-for="item in overdueWorkList_" :key="item.consultantId"
                 style="flex-grow: 1; width: 160px; margin-left: 4px; display: flex; flex-direction: column">

              <div
                style="height: 40px; line-height: 40px; text-align: center; background-color: #136598; color: #f6f6f6; margin-bottom: 4px">
                {{item.consultantName}} ({{item.workList.length}})
              </div>

              <!--10, 10, 10 = 搜索下边距,中间分割, 最下边距-->
              <div style="overflow-y: auto; background-color: white; overflow-y: auto">
                <div v-for="work in item.workList" :key="work.id" class="card" style="cursor: pointer"
                     @click="check(work)">
                  <div>{{work.carNo | carNo}}</div>
                  <div>{{work.procedureName}}</div>
                  <div v-if="work.technicianName">{{work.technicianName}}</div>
                  <div v-else>当前无技师</div>
                  <div>{{new Date(work.estimateDeliveryTime).format('yyyy-MM-dd')}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div style="background-color: white; height: 10px"></div>

      <div style="flex-grow: 1; border-width: 2px" class="table-border" v-loading="loading">
        <div style="overflow-x: auto">
          <div style="display: flex;">
            <div v-for="(item, index) in otherWorkList_" :key="index"
                 style="margin-right: 4px; width: 160px; flex-shrink: 0">

              <div
                style="line-height: 40px; text-align: center; background-color: #136598; color: #f6f6f6; margin-bottom: 4px">
                {{days[index]}} ({{item.workList.length}})
              </div>

              <div
                style="overflow-y: auto; background-color: white; height: calc(50vh - 150px); font-size: 12px">
                <div v-for="work in item.workList" :key="work.id" class="card" style="cursor: pointer"
                     @click="check(work)">
                  <div style="margin: 6px 0">{{work.carNo | carNo}} ｜ {{work.consultantName}}</div>
                </div>
              </div>
            </div>
            <div style="margin-right: 4px; width:calc(1728px - 1152px); flex-shrink: 0;min-width: 300px;">
                <div style="line-height: 40px; text-align: center; background-color: #136598; color: #f6f6f6; margin-bottom: 4px">交车详细时间
                    <el-date-picker style="max-width: 190px;"
      v-model="DateValue"
      type="datetime"
      format="yyyy-MM-dd HH:mm:ss"
      placeholder="选择日期时间"
      @change="TimeTap()">
    </el-date-picker>
                </div>
                <div style="width:100%;height:calc(50vh - 150px);overflow-y: auto;background-color: white;">
                    <div style="font-size: 12px;display: flex;width: 100%;flex-wrap: wrap;">
                        <div v-for="work in this.newTimeList" :key="work.id" class="card" style="cursor: pointer;width: 140px;height: 30px;margin: 10px 10px;" @click="check(work)">
                            <div style="margin: 6px 0">{{work.carNo | carNo}} ｜ {{work.consultantName}}</div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <detail-work-dialog :visible.sync="dialog.showDetailWork" :work-id="dialog.workId"
                        pattern="READ_WORK"></detail-work-dialog>
  </div>
</template>

<script>
  import { deliveryPlan } from '@/utils/request'
  import DetailWorkDialog from '@/views/kanban/dialog/add-check/DetailWorkDialog'
  import { resizeCaptureMixin } from '@/views/mixins/ResizeCapture'

  export default {
    name: 'DeliveryPlan',
    mixins: [resizeCaptureMixin],
    components: { DetailWorkDialog },
    data () {
      return {
        loading: false,
        searchText: null,
        days: [
          '今天', '明天', '后天', ' 第四天', '第五天', '第六天', '第七天'
        ],
        overdueWorkList: [],
        otherWorkList: [],
        dialog: {
          workId: '',
          showDetailWork: false
        },
        DateValue: '',
        newTimeList: []

      }
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        for (const day of this.days) {
          this.otherWorkList.push({
            title: day,
            workList: []
          })
        }
        this.loading = true
        deliveryPlan().then(response => {
          this.overdueWorkList = response.data.overdueWorkList
          this.otherWorkList = response.data.otherWorkList
        }).finally(() => {
          this.loading = false
        })
      },
      check (work) {
        this.dialog.workId = work.id
        this.dialog.showDetailWork = true
      },
      TimeTap () {
        this.newTimeList = []
        if (this.DateValue === null) {
            return
        }
        var sDate = this.DateValue.format('yyyy-MM-dd hh:mm:ss')
        var eDate = this.DateValue.format('yyyy-MM-dd hh:mm:ss').slice(0, 14) + '59:59'
        this.overdueWorkList.forEach((v) => {
            if (v.workList.length > 0) {
                v.workList.forEach((val) => {
                    var time = val.estimateDeliveryTime
                    if (sDate <= time && time <= eDate) {
                        this.newTimeList.push(val)
                    }
                })
            }
        })
        this.otherWorkList.forEach((v) => {
            if (v.workList.length > 0) {
                v.workList.forEach((val) => {
                    var time = val.estimateDeliveryTime
                    if (sDate <= time && time <= eDate) {
                        this.newTimeList.push(val)
                    }
                })
            }
        })
      }
    },
    computed: {
      overdueContainerStyle () {
        if (!this.overdueWorkList) return {}

        return { width: (164 * this.overdueWorkList.length) + 'px' }
      },
      overdueWorkList_ () {
        if (!this.searchText) return this.overdueWorkList

        const ret = []

        for (const item of this.overdueWorkList) {
          ret.push({
            consultantId: item.consultantId,
            consultantName: item.consultantName,
            workList: item.workList.filter(work => work.carNo.indexOf(this.searchText) > -1)
          })
        }
        return ret
      },
      otherWorkList_ () {
        if (!this.searchText) return this.otherWorkList

        const ret = []

        for (const item of this.otherWorkList) {
          ret.push({
            workList: item.workList.filter(work => work.carNo.indexOf(this.searchText) > -1)
          })
        }
        return ret
      }
    }
  }
</script>

<style lang="scss" scoped>
  .card {
    text-align: center;
    border: 2px solid #b38a61;
    margin-bottom: 4px;
  }
  .jcdiv{
    width: 40px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
  }
</style>
